import { isMarketplace as isModernSubscriptionMarketplace } from '../internal/modernSubscription/isMarketplace';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function isMarketplace(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionMarketplace(subscription);
  }

  return false;
}
